import { useQuery } from '@tanstack/react-query';
import { getRugCheck, getRugCheckRecord } from '../lib/apiClient';
import type { RugChain } from '../lib/rugCheck';

/** One lookup. Runs only for a chain and a valid address. */
export function useRugCheck(chain: RugChain | null, address: string | null) {
  return useQuery({
    queryKey: ['rug-check', chain, address],
    queryFn: () => getRugCheck(chain!, address!),
    enabled: chain !== null && address !== null,
    staleTime: 60_000,
    retry: false,
  });
}

/** The track record changes at most hourly. */
export function useRugCheckRecord() {
  return useQuery({
    queryKey: ['rug-check-record'],
    queryFn: getRugCheckRecord,
    staleTime: 5 * 60_000,
  });
}
